module.exports = __webpack_public_path__ + "img/meter-order.c3c0193e.svg";